function one_day_ago() {
  return (new Date()).valueOf() - 24*3600*1000
}

function get_alerts() {
  if(localStorage.alerts == undefined) {
    return {}
  }
  return JSON.parse(localStorage.alerts)
}

const state = () => ({
})

const getters = {
  // this awfulness is to get around caching. past_due_alerts() must be a functional getter
  past_due_alerts: () => () => {
    let alerts = get_alerts()

    return Object.keys(alerts).filter(key => alerts[key] < one_day_ago())
  }
}

const actions = {
  set_alerts( { commit }, new_alert_keys ) {
    const old_alerts = get_alerts()

    let new_alerts = {}
    for(const key of new_alert_keys) {
      new_alerts[key] = 0
    }

    // save the last exposure date for any keys still in alert status
    for (const key of Object.keys(old_alerts)) {
      if (key in new_alerts)
        new_alerts[key] = old_alerts[key]
    }
    commit('PERSIST_ALERTS', new_alerts)
  },
}

const mutations = { 
  SNOOZE (_state, alert) {
    let alerts = get_alerts()
    alerts[alert] = (new Date()).valueOf()
    localStorage.alerts = JSON.stringify(alerts)
  },

  PERSIST_ALERTS (_state, new_alerts) {
    localStorage.alerts = JSON.stringify(new_alerts)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}